module.exports = "/_next/static/images/e6b2b9d732f4c91fe44721ee7f54fa45-cucuta-perks-lg-1x.jpg";